var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"cabecera"},[_c('div',{staticClass:"contenedor-logo"},[_c('router-link',{attrs:{"to":{ name: 'p1' }}},[_c('img',{staticClass:"logo-main",attrs:{"src":require("@/assets/images/logo_blanco.png"),"alt":"LOGO KIA"}})])],1),_c('div',{staticClass:"linea-divisoria"})])
}
var staticRenderFns = []

export { render, staticRenderFns }